import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Calendar } from 'react-date-range';
import moment from 'moment';
import qs from 'qs';
import Filter from './Filter';

export default class DateRangeFilter extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    expanded: PropTypes.bool,
    timezone: PropTypes.string,
    selected: PropTypes.arrayOf(PropTypes.shape({
      from: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired,
    })),
    onChange: PropTypes.func,
  }

  static defaultProps = {
    timezone: moment.tz.guess(),
    expanded: false,
    selected: null,
    onChange() {},
  }

  constructor(props) {
    super(props);
    const { startDate, endDate } = this.props.selected ? {
      startDate: new Date(moment.tz(this.props.selected.from, this.props.timezone).format('YYYY-MM-DD[T]HH:mm:ss')),
      endDate: new Date(moment.tz(this.props.selected.to, this.props.timezone).format('YYYY-MM-DD[T]HH:mm:ss')),
    } : {};

    this.state = {
      selected: startDate ? [{ startDate, endDate }] : [],
      preview: null,
      selectionInProgress: false,
    };
  }

  handleLocalResetClick = () => {
    const selected = [];
    this.setState({
      selected: [],
      preview: null,
      selectionInProgress: false,
    }, () => {
      this.syncReset();
      this.props.onChange('selected', { id: this.props.id, selected });
    });
  }

  handleGlobalResetClick = () => {
    const selected = [];
    this.setState({
      selected: [],
      preview: null,
      selectionInProgress: false,
    }, () => {
      this.props.onChange('selected', { id: this.props.id, selected });
    });
  }

  renderMonthAndYear(focusedDate, changeShownDate, props) {
    const {
      showMonthArrow, locale, minDate, maxDate, showMonthAndYearPickers,
    } = props;
    const upperYearLimit = (maxDate || Calendar.defaultProps.maxDate).getFullYear();
    const lowerYearLimit = (minDate || Calendar.defaultProps.minDate).getFullYear();
    return (
      <div onMouseUp={e => e.stopPropagation()} className="u-px-1">
        <div className="u-flex u-items-center u-justify-between">
          <div>
            {showMonthAndYearPickers ? (
              <span>
                <span>
                  <select
                    value={focusedDate.getMonth()}
                    onChange={e => changeShownDate(e.target.value, 'setMonth')}>
                    {locale.localize.months().map((month, i) => (
                      <option key={i} value={i}>
                        {month}
                      </option>
                    ))}
                  </select>
                </span>
                <span />
                <span>
                  <select
                    value={focusedDate.getFullYear()}
                    onChange={e => changeShownDate(e.target.value, 'setYear')}>
                    {new Array(upperYearLimit - lowerYearLimit + 1)
                      .fill(upperYearLimit)
                      .map((val, i) => {
                        const year = val - i;
                        return (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        );
                      })}
                  </select>
                </span>
              </span>
            ) : (
              <span className="u-font-semibold">
                {locale.localize.month(focusedDate.getMonth())}
                {' '}
                {focusedDate.getFullYear()}
              </span>
            )}
          </div>
          <div className="u-flex u-items-center u-justify-end">
            {showMonthArrow ? (
              <button
                type="button"
                className="u-rounded-full u-bg-old-primary-color-blue u-text-white u-h-3 u-w-3 u-flex u-items-center u-justify-center u-mr-1"
                onClick={() => changeShownDate(-1, 'monthOffset')}>
                <i className="Icon Icon-chevron-left u-text-xs u-mr-0" />
              </button>
            ) : null}
            {showMonthArrow ? (
              <button
                type="button"
                className="u-rounded-full u-bg-old-primary-color-blue u-text-white u-h-3 u-w-3 u-flex u-items-center u-justify-center"
                onClick={() => changeShownDate(+1, 'monthOffset')}>
                <i className="Icon Icon-chevron-right u-text-x u-mr-0" />
              </button>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  onChange = (val) => {
    if (!this.state.selectionInProgress) {
      this.setState({
        selected: [{ startDate: val, endDate: val }],
        selectionInProgress: true,
      });
    } else {
      this.setState((state) => ({
        selected: [{ startDate: state.preview.startDate, endDate: state.preview.endDate }],
        preview: null,
        selectionInProgress: false,
      }), this.syncCallback);
    }
  };

  syncReset = () => {
    const params = qs.parse(window.location.search.slice(1));
    if (params.page) delete params.page;
    if (params[this.props.id]) delete params[this.props.id];

    this.syncRouter(params);
  }

  syncCallback = () => {
    const { startDate, endDate } = this.state.selected[0];
    const params = qs.parse(window.location.search.slice(1));
    params[this.props.id] = {
      from: moment.tz(moment(startDate).format('YYYY-MM-DD[T]HH:mm:ss'), this.props.timezone).startOf('day').format(),
      to: moment.tz(moment(endDate).format('YYYY-MM-DD[T]HH:mm:ss'), this.props.timezone).endOf('day').format(),
    };
    if (params.page) delete params.page;

    this.syncRouter(params);
    this.props.onChange('selected', { id: this.props.id, selected: params[this.props.id] });
  };

  syncRouter = (params) => {
    router.push({
      pathname: window.location.pathname,
      search: qs.stringify(params, { arrayFormat: 'brackets', depth: 2 }),
      state: { revisitWithSearch: true },
    });
  };

  onPreviewChange = (val) => {
    if (!val && !this.state.selectionInProgress) {
      this.setState({ preview: null });
      return;
    }
    if (!this.state.selectionInProgress) {
      this.setState({
        preview: {
          clickedDate: val,
          startDate: val,
          endDate: val,
        },
      });
    } else if (moment(val).startOf('day').isBefore(moment(this.state.preview.clickedDate).startOf('day'))) {
      this.setState({
        preview: {
          clickedDate: this.state.preview.clickedDate,
          startDate: val,
          endDate: this.state.preview.clickedDate,
        },
      });
    } else {
      this.setState({
        preview: {
          clickedDate: this.state.preview.clickedDate,
          endDate: val,
          startDate: this.state.preview.clickedDate,
        },
      });
    }
  };

  render() {
    const {
      id, title, expanded, onChange,
    } = this.props;
    return (
      <Filter
        id={id}
        title={title}
        expanded={expanded}
        hasSelected={this.state.selected.length > 0}
        onChange={onChange}
        onLocalReset={this.handleLocalResetClick}
        onGlobalReset={this.handleGlobalResetClick}
      >
        <div className="Form u-px-3 u-pb-2">
          <Calendar
            showDateDisplay={false}
            preview={this.state.preview}
            showMonthAndYearPickers={false}
            moveRangeOnFirstSelection={false}
            displayMode="dateRange"
            navigatorRenderer={this.renderMonthAndYear}
            onChange={this.onChange}
            onPreviewChange={this.onPreviewChange}
            onRangeFocusChange={this.onRangeFocusChange}
            onShownDateChange={this.onShownDateChange}
            updateRange={this.updateRange}
            ranges={this.state.selected}
          />
        </div>
      </Filter>
    );
  }
}
